
const urlHelper = (raw: string) => new Url(raw);

export {
    urlHelper,
}

export interface IAppendParamOnUrlProps {
    rawUrl: string;
    name: string;
    value: string;
    concatSymbol?: string;
}

export interface IUrlParam {
    key: string;
    value: string;
}

export class Url {
    path: string;
    queryParams: IUrlParam[];

    constructor(raw: string) {
        const [path, rawQueryParams] = raw.split('?');
        this.path = path;
        
        if (rawQueryParams) {
            this.queryParams = rawQueryParams.split('&').map((param: string) => {
                const [ key, value ] = param.split('=');
                return { key, value }
            });
        } else {
            this.queryParams = [];
        }
    }

    addQueryParam(key: string, value: string, concatSymbol?: string): Url {
        const hasKey = this.queryParams.find((param: IUrlParam) => param.key === key);
        
        if (hasKey) {
            this.queryParams = this.queryParams.map((param: IUrlParam) => {
                const values = [param.value];

                if (param.key === key) {
                    values.push(value);
                }
                
                return { 
                    key: param.key,
                    value: values.join(concatSymbol || '-'),
                };
            });
        } else {
            this.queryParams.push({ key, value });
        }
        return this;
    }

    toString(): string {
        if (this.queryParams.length === 0) {
            return this.path;
        }
        
        const queryParamsRaw = this.queryParams
            .map((param: IUrlParam) => param.key + '=' + param.value).join('&');        
        
        return [this.path, queryParamsRaw].join('?');
    }
}